<template>
  <div>
    <el-date-picker
      v-model="valueS"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="开始日期"
      @change="changeValue('valueS')"
      :style="{'width': width ? width+'px' : ''}"
    >
    </el-date-picker>
    <span>
            至
  </span>
    <el-date-picker
      v-model="valueE"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="结束日期"
      @change="changeValue('valueE')"
      :style="{'width': width ? width+'px' : ''}"
    >
    </el-date-picker>
  </div>

</template>

<script>
  export default {
    name: 'DateTimeInterval',
    data() {
      return {
        valueS:'',
        valueE:'',
      }
    },
    props: 
      ["value","width"],
    methods: {
      changeValue(zdm){
        if (this.valueS!=null&&this.valueE!=null&&
          new Date(this.valueS)>new Date(this.valueE)) {
          this[zdm] = ''
          this.$message.error("开始日期不可大于结束日期")
        }
        var value = [this.valueS,this.valueE]
        this.currentValue = value

      }
    },
    watch: {
        value: {
          handler(val) {
              if (val!=undefined) {
                if (typeof(val)=='string') {
                    var val_array = val_s.split(",");
                    if (val_array.length>1){
                        if (val_array[0].length<4){
                            this.valueS = "";
                        } else {
                            this.valueS =val_array[0];
                        }
                        if (val_array[1].length<4){
                            this.valueE = "";
                        } else {
                            this.valueE =val_array[1];
                        }
                    }
                }else {
                    this.valueS =val[0];
                    this.valueE =val[1];

                }
            } else {
              this.valueE = '';
              this.valueS = '';
              return;
            }
          },
          deep: true,
          immediate: true
        }
    },
    created() {
      // this.panel = getPanel(this.type);
    },
    computed: {
      currentValue: {
        get() {
          return this.value;
        },
        set(newVal) {
          this.$emit('input', newVal);
        }
      }
    }
  }
</script>
